<template>
  <div class="NotFound" data-testid="not-found-root">
    <h1 class="NotFound__title">404</h1>
  </div>
</template>


<style scoped lang="scss">
  .NotFound {
    background: var(--Global--tint-color);
    color: var(--Global--tint-inverse-color);
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
  }

  .NotFound__title {
    font-size: 400%;
    font-weight: 300;
  }
</style>
